import { Component, Inject } from '@angular/core';
import { Constant } from '../../constant';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonUtil } from '../../util/common-util';
import { ToastUtil } from '../../util/toast-util';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../../auth/auth.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

interface OrgNode {
  id: number;
  name: string;
  children?: OrgNode[];
  path?: string;
  checked?: boolean;
  manual?: boolean;
  org_count?: number;
}
@Component({
    selector: 'app-manager-edit-dialog',
    templateUrl: './manager-edit-dialog.component.html',
    styleUrl: './manager-edit-dialog.component.css',
    standalone: false,
})
export class ManagerEditDialogComponent {
  public readonly Constant = Constant;
  public form: FormGroup;
  public isSaving = false;
  public maxLenColor = 6
  //public mainColor
  public colorPreviewId = 'main-color-preview'
  private apiPath = '/master';
  public auths;
  public accountAuth;
  public mailaddress;
  public account;
  public showSpinner = true;
  public currentAuth;
  public loginAuthCode: number;
  public treeControl = new NestedTreeControl<OrgNode>(node => node.children);
  public dataSource = new MatTreeNestedDataSource<OrgNode>();
  public selectedNodes: OrgNode[] = [];
  public showClearAll = false;
  public isAllSelected = false;
  public readonly ZENBU_ID = -1;
  public readonly TANO_ID = -2;

  hasChild = (_: number, node: OrgNode) =>
    !!node.children && node.children.length > 0;
  trackByFn = (_: number, node: OrgNode) => node.id;
  constructor(
    public dialogRef: MatDialogRef<ManagerEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auth: AuthService,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
  ) {



  }

  ngOnInit() {
    this.showClearAll = !!this.data?.showClearAll;
    this.getDetail();
  }

  onClearAll(event?: Event): void {
    // SPでは押したあともボタンにフォーカス（押した見た目）が残るため、外す
    (event?.currentTarget as HTMLElement | null)?.blur();
    this.isAllSelected = false;
    const traverse = (nodes: OrgNode[]) => {
      for (const node of nodes) {
        node.checked = false;
        node.manual = false;
        if (node.children) traverse(node.children);
      }
    };
    traverse(this.dataSource.data);
  }

  onSave() {
    if (!this.commonUtil.checkOnline()) {
      this.isSaving = false;
      return;
    }

    if (this.isSaving) {
      return;
    }

    this.isSaving = true;

    const selected = this.getSelectedNodes().map(node => {
      if (node.id === this.ZENBU_ID || node.id === this.TANO_ID) {
        return { ...node, path: node.name, master_type: 0 };
      }

      // node.level だけでなく、ルートの親で判定して master_type を割り当て
      const root = this.getRootNode(node);
      const masterTypeMap: { [key: string]: number } = { '本部': 1, '支部': 2, 'エリア': 3, '専門部': 4 };
      const master_type = masterTypeMap[root.name] ?? 0;

      return {
        ...node,
        path: this.getPath(node),
        level: this.getDisplayLevel(node),
        master_type,
        org_count: node.org_count,
      };
    });

    this.dialogRef.close(selected);
  }

  private getRootNode(node: OrgNode): OrgNode {
    let current = node;
    let parent = this.findParent(this.dataSource.data, current);

    while (parent) {
      current = parent;
      parent = this.findParent(this.dataSource.data, current);
    }

    return current;
  }

  getDisplayLevel(node: OrgNode): number {
    let level = 0;
    let current: OrgNode | null = node;

    while (current) {

        level++;

      current = this.findParent(this.dataSource.data, current);
    }

    return level - 1; // ルートを0にする
  }

  onInput() {
    const mail_address = this.form.value.mail_address;

    if (mail_address.length < 6) {
      return
    }

  }

  onChange() {
    const auth = this.form.value.accountAuth;

    if (auth.length < 6) {
      return
    }

  }

  onCompositionEnd() {
    this.onInput()
  }

  getLevel(node: OrgNode): number {
    let level = 0;
    let parent = this.findParent(this.dataSource.data, node);
    while (parent) {
      level++;
      parent = this.findParent(this.dataSource.data, parent);
    }
    return level;
  }

  private findParent(nodes: OrgNode[], target: OrgNode): OrgNode | null {
    for (const node of nodes) {
      if (node.children?.includes(target)) {
        return node;
      }
      const found = this.findParent(node.children || [], target);
      if (found) return found;
    }
    return null;
  }

    /* プライベート */
  // 詳細取得
  private getDetail() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      this.dialogRef.close();
      return;
    }

    Auth.currentSession().then(session => {
      const apiPath = this.apiPath;
      const options = this.auth.createApiHeader(session);
      this.commonUtil.apiGet(apiPath, options).then(res => {
        if (!res.data) {
          // 削除済み
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgDeleteAccountAlreadyError, Constant.toastShowMiliSec);
          this.dialogRef.close(true);
          return;
        }
        const master = res.data.master;
        this.initTree(master);
        this.showSpinner = false;
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
        if (err.message === Constant.msgLoginFailed) {
          this.commonUtil.showReloadDialog(this.auth);
        } else {
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
          this.dialogRef.close();
        }
      });
    });
  }

  private normalize(nodes: any[]): OrgNode[] {
    return nodes.map(n => {
      const isSkip = n.name?.includes('#skip');

      return {
        id: n.id,
        name: n.name,
        // skipでも children はそのまま
        children: this.normalize(n.children ?? []),
        // フラグ追加
        skip: isSkip
      };
    });
  }

  private initTree(master) {

    const honbu: OrgNode = {
      id: 1,
      name: '本部',
      children: this.normalize(master['1'] ?? [])
    };

    const shibu: OrgNode = {
      id: 2,
      name: '支部',
      children: this.normalize(master['2'] ?? [])
    };

    const area: OrgNode = {
      id: 3,
      name: 'エリア',
      children: this.normalize(master['3'] ?? [])
    };

    const nodes: OrgNode[] = [];
    let senmonbu: OrgNode | null = null;
    let zenbu: OrgNode | null = null;
    let tanoOrg: OrgNode | null = null;

    if (this.data?.isTargetOrg) {
      zenbu = { id: this.ZENBU_ID, name: '全体' };
      nodes.push(zenbu);
    }

    nodes.push(honbu, shibu, area);

    if (this.data?.showSenmonbu) {
      senmonbu = {
        id: 4,
        name: '専門部',
        children: this.normalize(master['4'] ?? [])
      };
      nodes.push(senmonbu);
    }

    if (this.data?.isTargetOrg) {
      tanoOrg = { id: this.TANO_ID, name: '他組織' };
      nodes.push(tanoOrg);
    }

    this.dataSource.data = nodes;

    this.applyMemberCount(master);
    this.applySelected(this.data?.selected || []);
    this.expandSkipNodes(this.dataSource.data);
    this.expandCheckedAncestors(this.dataSource.data);

    // 全体が選択済みかチェック
    if (zenbu && zenbu.checked) {
      this.isAllSelected = true;
    }

    this.expandCheckedNodes(this.dataSource.data);

    this.treeControl.expand(honbu);
    this.treeControl.expand(shibu);
    this.treeControl.expand(area);
    if (senmonbu) this.treeControl.expand(senmonbu);

  }

  applySelected(selectedList: any[]) {

    const traverse = (nodes: OrgNode[]) => {

      for (const node of nodes) {

        const match = selectedList.find(s => {

          // 本部・支部・エリア・専門部
          if (s.id == null) {

            if (node.name === '本部') {
              return s.master_type === 1;
            }

            if (node.name === '支部') {
              return s.master_type === 2;
            }

            if (node.name === 'エリア') {
              return s.master_type === 3;
            }

            if (node.name === '専門部') {
              return s.master_type === 4;
            }
          }

          return s.id === node.id;
        });

        if (match && !(node as any).skip) {

          node.checked = true;
          node.manual = true;

          if (match.org_count != null) {
            node.org_count = match.org_count;
          }
        }

        if (node.children) {
          traverse(node.children);
        }
      }
    };

    traverse(this.dataSource.data);
  }

  private applyMemberCount(masterData: any) {
    const traverse = (nodes: OrgNode[], category?: string) => {
      for (const node of nodes) {
        // node.id に一致する member_count を探す
        for (const key of Object.keys(masterData)) {
          const masterNodes = masterData[key] as any[];
          const found = findNodeById(masterNodes, node.id);
          if (found && found.member_count !== undefined) {
            node.org_count = found.member_count;
            break;
          }
        }

        if (node.children) {
          traverse(node.children);
        }
      }
    };

    const findNodeById = (nodes: any[], id: number): any | null => {
      for (const n of nodes) {
        if (n.id === id) return n;
        if (n.children) {
          const childFound = findNodeById(n.children, id);
          if (childFound) return childFound;
        }
      }
      return null;
    };

    traverse(this.dataSource.data);
  }

  private initForm() {
    this.form = new FormGroup({
      mailaddress: new FormControl(this.account.user_id, [Validators.required]),
      accountAuth: new FormControl(
        String(this.account.user_authority),
        Validators.required
      ),
    });
    this.currentAuth = this.form.get('accountAuth')?.value;
    //this.form.get('mailaddress')?.disable({ emitEvent: false });
  }

  expandCheckedAncestors(nodes: OrgNode[]): boolean {
    let hasChecked = false;
    for (const node of nodes) {
      const childHasChecked = node.children ? this.expandCheckedAncestors(node.children) : false;
      if (childHasChecked) {
        this.treeControl.expand(node);
        hasChecked = true;
      }
      if (node.checked) {
        hasChecked = true;
      }
    }
    return hasChecked;
  }

  expandSkipNodes(nodes: OrgNode[]) {
    for (const node of nodes) {

      if ((node as any).skip) {
        this.treeControl.expand(node); // 強制展開
      }

      if (node.children) {
        this.expandSkipNodes(node.children);
      }
    }
  }

  getPath(node: OrgNode): string {
    const path: string[] = [];

    let current: OrgNode | null = node;

    while (current) {

      if (!(current as any).skip) {
        path.unshift(current.name);
      }

      current = this.findParent(this.dataSource.data, current);
    }

    return path.join(' ');
  }

  toggleNode(node: OrgNode, checked: boolean) {
    if (node.id === this.ZENBU_ID) {
      node.checked = checked;
      node.manual = checked;
      this.isAllSelected = checked;
      if (checked) {
        const uncheckAll = (nodes: OrgNode[]) => {
          for (const n of nodes) {
            if (n.id !== this.ZENBU_ID) {
              n.checked = false;
              n.manual = false;
            }
            if (n.children) uncheckAll(n.children);
          }
        };
        uncheckAll(this.dataSource.data);
      }
      return;
    }

    // 自分だけ更新
    node.checked = checked;

    if (!(node as any).skip) {
      node.manual = checked;
    }

    // ------------------------
    // 親にチェックONした時だけ
    // 子へ伝播
    // ------------------------
    if (
      checked &&
      node.children &&
      node.children.length > 0
    ) {

      // アコーディオン展開
      this.treeControl.expand(node);

      // 1階層下だけ全部チェック
      //for (const child of node.children) {

      //  child.checked = true;

      //  if (!(child as any).skip) {
      //    child.manual = true;
      //  }

      //}
    }
  }

  uncheckChildren(node: OrgNode) {
    if (!node.children) return;

    for (const child of node.children) {
      child.checked = false;
      child.manual = false; // 👈 今回は消すのが正解

      //this.uncheckChildren(child);
    }
  }

  checkParents(node: OrgNode) {
    let parent = this.findParent(this.dataSource.data, node);

    while (parent) {
      parent.checked = true;

      // これを追加（超重要）
      parent.manual = true;

      parent = this.findParent(this.dataSource.data, parent);
    }
  }

  getSelectedNodes(): OrgNode[] {
    const result: OrgNode[] = [];

    const traverse = (nodes: OrgNode[]) => {
      for (const node of nodes) {

        //onst hasManualChild = node.children?.some(child => child.manual);

        // 自分はmanualで、子にmanualがいない
        if (node.manual){ //&& !hasManualChild) {
          result.push(node);
        }

        if (node.children) {
          traverse(node.children);
        }
      }
    };

    traverse(this.dataSource.data);
    return result;
  }

  isParentChecked(node: OrgNode): boolean {
    let parent = this.findParent(this.dataSource.data, node);

    while (parent) {
      if (parent.checked) return true;
      parent = this.findParent(this.dataSource.data, parent);
    }

    return false;
  }

  onCheck(node: OrgNode, checked: boolean) {
    if (checked) {
      this.selectedNodes.push(node);
    } else {
      this.selectedNodes = this.selectedNodes.filter(n => n.id !== node.id);
    }
  }

  private expandCheckedNodes(nodes: OrgNode[]) {

    const traverse = (nodeList: OrgNode[]) => {

      for (const node of nodeList) {

        // checkedなら親方向をexpand
        if (node.checked) {

          let current: OrgNode | null = node;

          while (current) {

            this.treeControl.expand(current);

            current = this.findParent(
              this.dataSource.data,
              current
            );
          }
        }

        if (node.children?.length) {
          traverse(node.children);
        }
      }
    };

    traverse(nodes);
  }
}
